import { Component } from '@angular/core';

@Component({
    selector: 'ca-loading-indicator-with-text',
    templateUrl: './loading-indicator-with-text.component.html',
    styleUrls: ['./loading-indicator-with-text.component.scss'],
})
export class LoadingIndicatorWithTextComponent {}
